import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider} from 'react-redux'
import "./bootstrap.min.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { store } from "./services/store";
import axios from "axios";

axios.defaults.baseURL="https://av-pets-mern-api.vercel.app/"


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
